/* Copyright (c) 2021-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { StatusCodeZeroErrorTypes } from 'nv-angular-http-endpoint/lib/constants/constants';

export interface DNSLookupEntry {
    lookupSuccessful: boolean;
    lastUpdatedTs: number;
    destinationIp: string;
}

export interface DNSLookupSuccessResponse {
    hostname: string;
}

export interface ErrorAnalysisInfo {
    statusCode: StatusCodeZeroErrorTypes;
    cachedDNSEntry?: DNSLookupEntry;
}

export interface FailedRequestInfo {
    requestUrl: string;
    isCancelled?: boolean;
    uniqueRequestId?: string;
}

export const UNKNOWN_ERROR: ErrorAnalysisInfo = {
    statusCode: StatusCodeZeroErrorTypes.UnknownError
};

export interface StatusCodeZeroAnalyzerConfig {
    dnsCacheValidity: number;
}
